import { flatten } from 'underscore';
import { getFieldDefinition } from '../constants/templateEditor/KnowledgeBaseSettingsModule';
function getPathsAndValues(obj, prevObj) {
  // @ts-expect-error ts-migrate(7023) FIXME: 'rec' implicitly has return type 'any' because it ... Remove this comment to see the full error message
  const rec = (keyPath, _obj, _prevObj) => {
    return Object.keys(_obj).map(key => {
      const val = _obj[key];
      const prevVal = _prevObj[key];
      const isLeaf = typeof val !== 'object' || val === null || Array.isArray(val);
      const isNewObject = !isLeaf && (prevVal === null || typeof prevVal === 'undefined');
      return isLeaf || isNewObject ? {
        keyPath: [...keyPath, key],
        value: val
      } : rec([...keyPath, key], val, prevVal);
    });
  };
  return flatten(rec([], obj, prevObj));
}
export function validateField(field, value, keyPath, oldModuleValues) {
  if (!field || !field._validate) {
    return null;
  }
  return field._validate(value, keyPath, oldModuleValues);
}
export function addFieldErrors(fullPath, value, errors) {
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 4 arguments, but got 3.
  const fieldErrors = validateField(
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
  getFieldDefinition(fullPath), value, fullPath);
  if (fieldErrors) {
    return Object.assign({}, errors, fieldErrors);
  }
  return errors;
}
export function validateAll(templateSettings) {
  let errors = {};
  const {
    knowledgeBaseSettings,
    themeSettings
  } = templateSettings.toJS();
  getPathsAndValues(knowledgeBaseSettings, {}).forEach(({
    keyPath,
    value
  }) => {
    const fullPath = ['knowledgeBaseSettings'].concat(keyPath);
    errors = addFieldErrors(fullPath, value, errors);
  });
  getPathsAndValues(themeSettings, {}).forEach(({
    keyPath,
    value
  }) => {
    const fullPath = ['themeSettings'].concat(keyPath);
    errors = addFieldErrors(fullPath, value, errors);
  });
  return errors;
}